export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    displayName: '',
    supperAdmin: false,
    userinfo: {
    },
    orgInfo:{},
    entId:'',
    selectInternalRoleId:'',
    internalRoleIds:[],
    //自定义----- roleNum1:业主 roleNum2:中介机构 roleNum3:涉批中介  roleNum4审核人
    orgInternalRoleIds:[],//角色类型 1515390002424013业主 / 1515390002424014中介 / 1515390002424015涉批中介   数组
    userPerms:[],// 用户按钮权限
    pageRoleIdsNum:'',//默认获取数组第一个   真实角色类型
  
    roleIdsArr:[],//审核人类型 数组 5940cdc0c3ce4af990baa5d16ed3f271 
    roleIdsNum:'', //审核人类型    真实角色类型
   
    pageRoleIds:'', //自定义角色类型(业主\中介机构\涉批中介)
    roleIds :'',  //自定义审核角色类型 

    attributes:'',//登录ip和时间
    orgId:'',//项目业主id
    orgName:'',//项目业主名称
    username:'',//用户名
    noRoleId:''
  },
  mutations: {
    updatePageRoleIdsNum (state, id) {
      state.pageRoleIdsNum = id
    },
    updateNoRoleId (state, id) {
      state.noRoleId = id
    },
    updateRoleIdsNum (state, id) {
      state.roleIdsNum = id
    },
    updateRoleIdsArr (state, id) {
      state.roleIdsArr = id
    },
    updateRoleIds (state, id) {
      state.roleIds = id
    },
    updateUsername (state, id) {
      state.username = id
    },
    updateAttributes (state, id) {
      state.attributes = id
    },
    updateUserPerms (state, id) {
      state.userPerms = id
    },
    updateOrgName(state,name){
      state.orgName = name
    },
    updateOrgInternalRoleIds (state, id) {
      state.orgInternalRoleIds = id
    },
    updatePageRoleIds (state, id) {
      state.pageRoleIds = id
    },
    updateId (state, id) {
      state.id = id
    },
    updateUser (state, userinfo) {
      state.userinfo = userinfo
    },
    updateName (state, name) {
      state.name = name
    },
    updateDisplayName (state, name) {
      state.displayName = name
    },
    updateSupperAdmin (state, name) {
      state.supperAdmin = name
    },
    updateOrgInfo (state, orgInfo) {
      state.orgInfo = orgInfo
    },
    updateOrgId (state, orgId) {
      state.orgId = orgId
    },
    updateEntId (state, entId) {
      state.entId = entId
    },
    updateSelectInternalRoleId (state, selectInternalRoleId) {
      state.selectInternalRoleId = selectInternalRoleId
    },
    updateInternalRoleIds (state, internalRoleIds) {
      state.internalRoleIds = internalRoleIds
    }
  }
}
